import { render } from "./SupplierGradeModal.vue?vue&type=template&id=79c6ce54&scoped=true&ts=true&lang=pug"
import script from "./SupplierGradeModal.vue?vue&type=script&lang=ts"
export * from "./SupplierGradeModal.vue?vue&type=script&lang=ts"

import "./SupplierGradeModal.vue?vue&type=style&index=0&id=79c6ce54&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6ce54"]])

export default __exports__